module.exports = __webpack_public_path__ + "img/logo-white.8666aca0.png";